export default __webpack_public_path__ + "static/media/Metro-1.d7cc8b9b.svg";